import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
// redux
import { connect } from 'react-redux';

// classnames
import classNames from 'classnames';

// jl-design-system
import { Message } from 'jl-design-system/components/message/v2/Message';
import Tooltip from 'jl-design-system/components/tooltip/Tooltip';
import { UnderlinedButton } from 'jl-design-system/elements/button/Button';

// constants
import editBasketConstants from '../../../constants/editBasketConstants';
import tradeInConstants from '../../../constants/tradeInConstants';

import EditBasketItemOverlay from '../../edit-basket-item-overlay/EditBasketItemOverlay';

import styles from './trade-in-item.scss';

export const TradeInItem = ({
  editBasketItemRemoveOverlayIds,
  editBasketRemoveItemApiCallActiveIds,
  handleRemoveItem,
  hideItemRemoveOverlay,
  index,
  isModalView,
  isProcessing,
  itemId,
  itemName,
  itemPaymentAmount,
  itemPaymentType,
  showItemRemoveOverlay,
  showTradeInBoxInOrderConfirmation,
}) => {
  const [overlayType, setOverlayType] = useState('');

  const tradeInItemClassNames = classNames(styles.tradeInItem, {
    [styles.orderConfirmationView]: showTradeInBoxInOrderConfirmation,
  });

  const tooltipId = isModalView ? `clickModalTradeInItemTooltip-${index}` : `clickTradeInItemTooltip-${index}`;

  const isRemoveItemApiCallActive = editBasketRemoveItemApiCallActiveIds.includes(itemId);

  const isZeroValueTradeIn = itemPaymentAmount === '£0';

  const tradeinMessage = showTradeInBoxInOrderConfirmation ? (
    <>
      Trade-in for the value of <strong>{itemPaymentAmount}</strong> which will be paid after our device assessment
    </>
  ) : (
    <>
      Checkout to confirm your trade-in for the value of
      {' '}
      <strong>{itemPaymentAmount}</strong>
    </>);

  const zeroValueTradeinMessage = 'Checkout to confirm your device for recycling';

  const getTradeinInfoBoxMessage = isZeroValueTradeIn ? zeroValueTradeinMessage : tradeinMessage;

  useEffect(() => {
    const type = editBasketItemRemoveOverlayIds.includes(itemId) ? editBasketConstants.REMOVE_TRADE_IN_ITEM : '';
    setOverlayType(type);
  }, [editBasketItemRemoveOverlayIds]);

  const paymentText = itemPaymentType === tradeInConstants.GIFT_CARD ?
    'by e-gift card' :
    'By Bank Transfer or PayPal';

  return (
    <div key={`trade-in-item-${index}`} className={tradeInItemClassNames} data-test={`trade-in-item-${index}`}>
      <div className={styles.itemInnerContainer}>
        <h5 className={styles.title} data-test={`tradein-item-name${index}`}>
          {itemName} Trade-in
        </h5>
        {
          (!showTradeInBoxInOrderConfirmation || !isZeroValueTradeIn) &&
          <Message
            body={getTradeinInfoBoxMessage}
            dataTest={`tradein-amended-message-${index}`}
            type="information"
          />
        }
        <p data-test="tradein-item-quantity">Quantity: 1</p>

        {isModalView &&
          <UnderlinedButton
            className={styles.removeButton}
            data-test={`remove-tradein-button-${index}`}
            disabled={isProcessing}
            onClick={() => showItemRemoveOverlay(itemId)}
          >
            Remove
          </UnderlinedButton>}

        {
          !showTradeInBoxInOrderConfirmation && !isZeroValueTradeIn &&
          <div>
            <Tooltip
              anchor="left"
              buttonLabel="Payout made later"
              data-test={`tradein-tooltip-${index}`}
              icon
              id={tooltipId}
            >
              <p data-test={`tradein-tooltip-instruction-${index}`}>
                Payment can take up to 3 working days after inspection.
              </p>
            </Tooltip>
            <p>{ paymentText }</p>
          </div>
        }
      </div>

      {(isModalView && overlayType) &&
        <EditBasketItemOverlay
          disabled={isProcessing}
          onRemoveNo={() => hideItemRemoveOverlay(itemId)}
          onRemoveYes={() => handleRemoveItem(itemId, false, false, true)}
          removeItemApiCallActive={isRemoveItemApiCallActive}
          type={overlayType}
        />}
    </div>
  );
};

TradeInItem.propTypes = {
  editBasketItemRemoveOverlayIds: PropTypes.arrayOf(PropTypes.string),
  editBasketRemoveItemApiCallActiveIds: PropTypes.arrayOf(PropTypes.string),
  handleRemoveItem: PropTypes.func,
  hideItemRemoveOverlay: PropTypes.func,
  index: PropTypes.number,
  isModalView: PropTypes.bool,
  isProcessing: PropTypes.bool,
  itemId: PropTypes.string,
  itemName: PropTypes.string,
  itemPaymentAmount: PropTypes.string,
  itemPaymentType: PropTypes.string,
  showItemRemoveOverlay: PropTypes.func,
  showTradeInBoxInOrderConfirmation: PropTypes.bool,
};

TradeInItem.defaultProps = {
  editBasketItemRemoveOverlayIds: [],
  editBasketRemoveItemApiCallActiveIds: [],
  handleRemoveItem: () => {},
  hideItemRemoveOverlay: () => {},
  index: 0,
  isModalView: false,
  isProcessing: false,
  itemId: '',
  itemName: '',
  itemPaymentAmount: '',
  itemPaymentType: '',
  showItemRemoveOverlay: () => {},
  showTradeInBoxInOrderConfirmation: false,
};

export function mapStateToProps(state) {
  return {
    editBasketItemRemoveOverlayIds: state.orderForm.editBasketItemRemoveOverlayIds,
    editBasketRemoveItemApiCallActiveIds: state.orderForm.editBasketRemoveItemApiCallActiveIds,
  };
}

export default connect(state => mapStateToProps(state))(TradeInItem);
